import { useMediaQuery } from "@mui/material";
import AboutUsWebView from "./AboutUsWebView";
import AboutUsMobileView from "./AboutMobileView";
export default function About() {
  const isSmallScreen = useMediaQuery("(max-width:960px)");
  return <>{isSmallScreen ? <AboutUsMobileView /> : <AboutUsWebView />}</>;
}
